
import { Image, clone } from "utils"
import SETTINGS from "settings"
import slot_config from 'cfg/slot-config'
import { action, clear_action, live } from 'actions'
import SlotWinPresenter from 'slot_win_presenter'

const ls = `
//ignoring (or not even declaring) this variable crashes PIXI:
varying vec2 vTextureCoord;
//comments at uniform section are NOT working when it's under PIXI ...

uniform sampler2D uSampler;

uniform vec4 filterArea;

uniform vec2 dimensions;

uniform vec2 ratio;

uniform float xs[ REELS ];
uniform float ys[ REELS ];
uniform float symbol_width;
uniform float symbol_height;

uniform bool visibility[ REELS ];

uniform vec2 screen_disp;

void main()
{
    vec2 pixel_coord = vTextureCoord * filterArea.xy + filterArea.zw;
    
    float cx = pixel_coord.x - screen_disp.x;
    float cy = pixel_coord.y - screen_disp.y;

    for ( int reel = 0; reel < REELS; ++ reel )
    {
        if ( visibility[ reel ] ) continue;
        
        if (
            (
                cx > xs[ reel ] * ratio.x
                &&
                cy > ys[ reel ] * ratio.y
            )
            &&
            (
                cx < ( xs[ reel ] + symbol_width ) * ratio.x
                &&
                cy < ( ys[ reel ] + symbol_height ) * ratio.y
            )
        )
        {
            //gl_FragColor = vec4( 1.0, 0.0, 0.0, 0.5 );
            return;
        }
    }
    
    //gl_FragColor = vec4( 0.0, 1.0, 0.0, 0.5 );
    gl_FragColor = texture2D( uSampler, vTextureCoord );
}
`

export default function( space, container, spec )
{
    if ( ! slot_config.whole_lines_filename_pattern ) return
    
    const lines = make_lines( space, container, spec )
    for ( const l of lines ) l.cloth.visible = false
        
    const visibility_whole = [ 1, 1, 1, 1, 1 ]
    
    const a = action()
    
    space.s( 'presenter:lines:show' ).on( ({ line, visibility }) => {
        const l = lines[ line ]
        l.cloth.visible = true
        if ( visibility ) l.shader.visibility = visibility
    } )
    space.s( 'presenter:lines:hide' ).on( ({ line }) => {
        lines[ line ].cloth.visible = false
    } )
    
    space.s( 'slot:linesChange' ).on( change => {
        clear_action( a )
        
        for ( let li = 0; li < lines.length; ++ li )
        {
            const l = lines[ li ]
            l.shader.uniforms.visibility = visibility_whole
            l.cloth.alpha = 1
            l.cloth.visible = li < change[ 1 ]
        }
        
        //hide later:
        a.push({ duration : 1.700 })
        const HIDE_IN = 0.460
        a.push({ duration : HIDE_IN, callback : k => {
            for ( const l of lines ) l.cloth.alpha = 1.0 - ( k / HIDE_IN )
        }})
    } )
    
    space.s( 'slot:spinStart' ).on( () => {
        clear_action( a )
        for ( const l of lines ) l.cloth.visible = false
    } )
    
    space.s( 'presenter:play_line' )
        .with( space.s( 'math' ), ( lo, math ) => ({ l : math.winLines()[ lo ], math }) )
        .on( ({ l, math }) => {
            clear_action( a )
            for ( const li in lines )
            {
                const line = lines[ li ]
                if ( li == l )
                {
                    line.cloth.visible = true
                    line.cloth.alpha = 1
                    if ( slot_config.barrel.crop_line )
                    {
                        const visibility = [ 1, 1, 1, 1, 1 ]
                        for ( const wp of math.lineWinPositions( l ) )
                        {
                            visibility[ SlotWinPresenter.symbol_index_to_pos( slot_config, wp ).col ] = 0
                        }
                        line.shader.uniforms.visibility = visibility
                    }
                }
                else
                {
                    line.cloth.visible = false
                }
            }
        } )
    
    space.s( 'ticker' ).on( s => live( a, s ) )
}

function make_lines( space, container, spec )
{
        
    const code = ls.replace( new RegExp( 'REELS', 'g' ), slot_config.barrel.reels.toString() )
    
    const lines = []

    for ( const line_path_index in spec.specification.linesPaths )
    {
        const cloth = Image( slot_config.whole_lines_filename_pattern.$( line_path_index ) )
        let image_disp = [ 0, 0 ]
        if ( slot_config.whole_lines_displacements ) image_disp = slot_config.whole_lines_displacements[ line_path_index ]
        cloth.position.set( ... image_disp )
        
        const p = {
            ratio : [ 1, 1 ],
            symbol_width : slot_config.barrel.cellSize.width,
            symbol_height : slot_config.barrel.cellSize.height,
            image_disp,
            screen_disp : [ 0, 0 ],
        }

        p.xs = []
        p.ys = []
        p.visibility = [ 1, 1, 1, 1, 1 ]
        const line_path = spec.specification.linesPaths[ line_path_index ]
        for ( let reel = 0; reel < line_path.length; ++ reel )
        {
            let x = slot_config.barrel.position.x + ( slot_config.barrel.cellSize.width + slot_config.barrel.reelGap ) * reel
            p.xs.push( x )

            let y = slot_config.barrel.position.y + slot_config.barrel.cellSize.height * line_path[ reel ]
            p.ys.push( y )
        }
        
        const shader = new PIXI.Filter(
            null,
            code,
            clone( p ),
        )
        shader.autoFit = false
        for ( const i in p ) shader.uniforms[ i ] = p[ i ]
        shader.apply = function(filterManager, input, output, clear)
        {
            this.uniforms.dimensions = [ input.sourceFrame.width, input.sourceFrame.height ]
            filterManager.applyFilter(this, input, output, clear);
        }

        space.s( "size" ).on( size => {
            shader.uniforms.ratio[ 0 ] = size.x / SETTINGS.screen.resolution.width
            shader.uniforms.ratio[ 1 ] = size.y / SETTINGS.screen.resolution.height
            
            shader.uniforms.screen_disp[ 0 ] = size.dx
            shader.uniforms.screen_disp[ 1 ] = size.dy
        } )
        
        cloth.filters = [ shader ]
        container.addChild( cloth )
        lines.push( {
            cloth,
            shader,
        } )
    }
    
    return lines;
}





// WEBPACK FOOTER //
// ./src/library/whole_line.es6